import { HttpErrorResponse } from '@angular/common/http';
import type { ErrorEvent, EventHint } from '@sentry/angular';

// Drop HTTP errors captured through global handlers; the HTTP client integration reports selected statuses separately.
export function beforeSend(
  event: ErrorEvent,
  hint: EventHint,
): ErrorEvent | null {
  return hint.originalException instanceof HttpErrorResponse ? null : event;
}
